import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/ministry`;
const resourceKpi = `${Repository.defaults.baseURL}/indicator-group`;
const resourceListUserV4 = `${Repository.defaults.baseURL}/v4/ministry`;
const resourceListLevel = `${Repository.defaults.baseURL}`;


export default {
    async list (params) {
        const response = await Repository.get(`${resource}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async detail (id) {
        const response = await Repository.get(`${resource}/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async create (body) {
        const response = await Repository.post(`${resource}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async update (id, body) {
        const response = await Repository.patch(`${resource}/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async delete (id) {
        const response = await Repository.delete(`${resource}/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createBranch (body) {
        const response = await Repository.post(`${resource}/org`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateBranch (id, body) {
        const response = await Repository.patch(`${resource}/org/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async deleteBranch (id) {
        const response = await Repository.delete(`${resource}/org/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async createRank (body) {
        const response = await Repository.post(`${resource}/rank`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateRank (id, body) {
        const response = await Repository.patch(`${resource}/rank/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async deleteRank (id) {
        const response = await Repository.delete(`${resource}/rank/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async listRankUser(params) {
        const response = await Repository.get(`${resource}/rank-user`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async changeRankUser(body) {
        const response = await Repository.post(`${resource}/rank-user/change`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateUserForRank (id, body) {
        const response = await Repository.post(`${resource}/rank-user/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async listKpi(params) {
        const response = await Repository.get(`${resourceKpi}`, {
            params,
            headers: TokenService.getHeader(),
        });
        return response
    },
    async updateKpiForBranch (id, body) {
        const response = await Repository.post(`${resource}/org-indicator/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async updateRolesForBranch (id, body) {
        const response = await Repository.post(`${resource}/org-role/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async listMinistryOnly() {
        const response = await Repository.get(`${resource}/list`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async childOrg(params) {
        const response = await Repository.get(`${resource}/org/child`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async pathMinistryOfUser(body) {
        const response = await Repository.post(`${resource}/rank/path`, body,{
            headers: TokenService.getHeader(),
        });
        return response
    },
    async listUser(params = {}) {
        const response = await Repository.get(`${resource}/list-user`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listUserContactAdvise(params = {}) {
        const response = await Repository.get(`${resource}/list-user-v2`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listRankForSelect(params = {}) {
        const response = await Repository.get(`${resource}/rank-user-allotment`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listUserV4(params = {}) {
        const response = await Repository.get(`${resourceListUserV4}/list-user`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listUserContactAdviseByLevel(params = {}) {
        const response = await Repository.get(`${resource}/list-user-v3`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listOrganizationByLevel(params = {}) {
        const response = await Repository.get(`${resource}/org/list-org-by-level`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listMinistryUserTree(params = {}) {
        const response = await Repository.get(`${resourceListUserV4}/list-user-by-ministry`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listUserByOrgLeve3(params = {}) {
        const response = await Repository.get(`${Repository.defaults.baseURL}/v4/ministry/list-user-by-org`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listOrgLeve2(params = {}) {
        const response = await Repository.get(`${Repository.defaults.baseURL}/v4/ministry/list-org-tree`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async listUserContactAdviseLevel2(params = {}) {
        const response = await Repository.get(`${resource}/list-user-v3`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async getListSchoolLevels(params = {}) {
        const response = await Repository.get(`${resourceListLevel}/type/school-level`, {
            params,
            headers: TokenService.getHeader()
        })
        console.log("reponse",response);
        return response
    },
}
